export const lightTheme = {
  isLight: true,
}

export const darkTheme = {
  isLight: false,
}